"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountConverter = void 0;
const LinkEntity_1 = require("../common/model/LinkEntity");
class AccountConverter {
}
exports.AccountConverter = AccountConverter;
AccountConverter.fromAccountsEntity = (entity) => {
    return entity.map((account) => AccountConverter.fromAccount(account));
};
AccountConverter.fromPageableAccountsEntity = (entity) => {
    return {
        page: AccountConverter.fromAccountsEntity(entity._embedded.accounts),
        pageSpec: {
            totalPages: entity.page.totalPages,
            number: entity.page.number,
            size: entity.page.size,
            totalElements: entity.page.totalElements,
        },
    };
};
AccountConverter.fromAccountEntity = (entity) => {
    return {
        id: entity.account.id,
        name: entity.account.name,
        products: entity.account.products?.map((productEntity) => productEntity),
        manager: entity.account.manager,
        status: entity.account.status,
        type: entity.account.type,
        marketSegment: entity.account.marketSegment,
        deliveryMethod: entity.account.deliveryMethod,
        defaultLicenseDurationYears: entity.account.defaultLicenseDurationYears,
        currency: entity.account.currency,
        features: entity.account.features,
        createdAt: entity.account.createdAt,
        accessExpiresOn: entity.account.accessExpiresOn,
        marketingInformation: entity.account.marketingInformation,
        totalActiveUsers: entity.account.totalActiveUsers,
        links: {
            deleteAccount: entity._links?.deleteAccount &&
                new LinkEntity_1.Link(entity._links?.deleteAccount),
            accountUsers: entity._links?.accountUsers && new LinkEntity_1.Link(entity._links?.accountUsers),
            accountBulkUsers: entity._links?.accountBulkUsers &&
                new LinkEntity_1.Link(entity._links?.accountBulkUsers),
            accountContentPackages: entity._links?.accountContentPackages &&
                new LinkEntity_1.Link(entity._links?.accountContentPackages),
        },
    };
};
AccountConverter.fromAccount = (account) => ({
    id: account.id,
    name: account.name,
    products: account.products?.map((productEntity) => productEntity),
    manager: account.manager,
    status: account.status,
    type: account.type,
    marketSegment: account.marketSegment,
    deliveryMethod: account.deliveryMethod,
    defaultLicenseDurationYears: account.defaultLicenseDurationYears,
    currency: account.currency,
    features: account.features,
    marketingInformation: account.marketingInformation,
    totalActiveUsers: account.totalActiveUsers,
});
AccountConverter.fromAccountPricesEntity = (entity) => {
    const assetTypePrices = entity.assetTypePrices?.map((it) => ({
        assetType: it.assetType,
        customPrice: it.customPrice,
        warning: it.warning,
        evaluatedPriceType: it.evaluatedPriceType,
        priceShownToUser: it.priceShownToUser,
    })) || [];
    const channelPrices = entity.channelPrices?.map((it) => ({
        channelId: it.channelId,
        customPrice: it.customPrice,
        channelName: it.channelName,
        isShownToUser: it.isShownToUser,
    })) || [];
    return {
        assetTypePrices: assetTypePrices,
        channelPrices: channelPrices,
        warning: entity.warning,
    };
};
AccountConverter.fromAccountApiClientEntity = (entity) => {
    return {
        id: entity.id,
        secret: entity.secret,
    };
};
//# sourceMappingURL=AccountConverter.js.map